import { Modal, Form, IFormContext } from 'rewire-ui';
import { INameEntity } from '../DataTypes';
import DataQueries from '../graphql/Queries';
import authService from '../services/AuthService';

let currentLocation: INameEntity;

const userLocationsSearch = {
  search(_search?: string) {
    return DataQueries.getUserLocations();
  },
  map(item: any) {
    return item?.name ?? '';
  },
};

export class SwitchLocationsModel extends Modal {
  form = Form.create((form: IFormContext) => ({
    location: form.select(userLocationsSearch).label('Location').validators('required').placeholder('switch to location'),
    // password: form.password().label('Password').validators('required').placeholder('enter your password'),
  }));

  constructor() {
    super('', false);
    this.action('switch location', this.submit, { type: 'submit' }).action('cancel', { icon: 'cancel' });
  }

  reset() {
    this.form.reset();
  }

  async load() {
    const returnSchema = `
      location {
        id
        name
      }
    `;
    currentLocation = (await DataQueries.getSessionInfo(returnSchema))?.location as INameEntity;
    this.form.value = { location: currentLocation };
    this.open();
  }

  private switchToLocation = async (): Promise<boolean> => {
    // const password      = this.form.field.password.value;
    const location = this.form.field.location.value;
    if (currentLocation?.id === location?.id) return true;
    return await authService.switchToLocation(location?.id, '');
  };

  submit = async (): Promise<boolean> => {
    return await this.form.submitAsync(this.switchToLocation);
  };
}

const switchLocationsModel = new SwitchLocationsModel();
export default switchLocationsModel;
